import documentApiClient, { ApiDefinition } from '@documentsApi';

type ThisApi = ApiDefinition['/document-request-users/{id}']['GET'];
type Input = ThisApi['params'];

const getDocumentRequestUser = async ({ id }: Input): Promise<ThisApi['response']> => {
  const response = await documentApiClient.get(`/document-request-users/${id}`);
  return response.data;
};

export default getDocumentRequestUser;
